<template>
  <ProductDisplay
    v-if="posts.length > 0"
    title="How you're wearing it"
    sub-title="Tag us @ratandboa and use the hashtag #RATANDBOA for a chance to be featured"
    color="grey"
  >
    <Carousel>
      <div v-for="post in posts" :key="post.id" ref="slides" class="slide">
        <div class="media">
          <img
            v-if="post.type === 'IMAGE'"
            :src="post.url"
            class="image"
            :alt="post.caption"
          />

          <Video
            v-if="post.type === 'VIDEO'"
            :video="{
              sources: [
                {
                  url: post.url,
                },
              ],
            }"
          >
          </Video>
        </div>

        <div class="info">
          <span v-if="post.like_count" class="info__likes">
            {{ post.like_count }} likes
          </span>
          <p class="info__caption">{{ post.caption }}</p>
        </div>
      </div>
    </Carousel>
  </ProductDisplay>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import Video from "@/components/Video.vue";
import ProductDisplay from "@/components/product-display/ProductDisplay.vue";
import { mapState } from "vuex";

export default {
  name: "HowToWearV2",
  components: {
    Video,
    Carousel,
    ProductDisplay,
  },
  computed: {
    ...mapState("product", ["product"]),
    posts() {
      const posts =
        this.product?.howToWear?.references?.edges?.map(
          (edges) => edges.node
        ) || [];

      const transformedPosts = posts
        .map((post) => {
          // Helper to get field value by key
          const getFieldValue = (key) => {
            const field = post.fields.find((f) => f.key === key);
            return field ? field.value : null;
          };

          // Get the media field which may contain video or image
          const mediaField = post.fields.find((f) => f.key === "media");
          let mediaUrl = null;
          let mediaType = "IMAGE";

          // If sources exist, always treat as video and use the first source's URL
          if (
            Array.isArray(mediaField?.reference?.sources) &&
            mediaField?.reference?.sources.length > 0
          ) {
            mediaUrl = mediaField.reference.sources[0].url;
            mediaType = "VIDEO";
          } else {
            // Fallback to previous logic if sources not present
            mediaUrl = mediaField?.reference?.image?.media || null;
            mediaType = getFieldValue("type") || "IMAGE";
          }

          return {
            id: post.id,
            type: mediaType,
            url: mediaUrl,
            caption: getFieldValue("caption") || "",
            like_count: parseInt(getFieldValue("like_count") || "0", 10),
          };
        })
        .sort((a, b) => {
          return new Date(b.timestamp || 0) - new Date(a.timestamp || 0);
        });

      return transformedPosts;
    },
  },
};
</script>

<style lang="scss" scoped>
.slide {
  .info {
    @include utility-body(14px);

    &__likes {
      display: block;
      margin-bottom: 4px;
    }

    &__caption {
      color: $color-grey-dark;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;

      * {
        display: inline;
      }
    }
  }

  .image,
  :deep(.video-intersection-observer),
  :deep(.video__element) {
    display: block;
    aspect-ratio: 4/5;
    object-fit: cover;
    max-width: 100%;
    margin-bottom: 12px;
  }
}
</style>
